import request from '@/utils/request';

export function calculatePrices(data) {
  return request({
    method: 'post',
    data: data,
    url: 'price-list-item-price/calculate-prices'
  });
}

export function changeMatrixPrices(data) {
  return request({
    method: 'post',
    data: data,
    url: 'price-list-item-price/change-matrix-prices'
  });
}

export function changePrices(data) {
  return request({
    method: 'post',
    data: data,
    url: 'price-list-item-price/change-prices'
  });
}

export function getLastPrices(params) {
  return request({
    method: 'get',
    params: params,
    url: 'price-list-item-price/last'
  });
}

export function getMatrix(priceListItemID) {
  return request({
    method: 'get',
    url: `price-list-item/${priceListItemID}/matrix`
  });
}

export function getPriceMatrix(params) {
  return request({
    method: 'get',
    params: params,
    url: 'price-list-item-price/matrix'
  });
}

export function getPrices(params) {
  return request({
    method: 'get',
    params: params,
    url: 'price-list-item-price'
  });
}

export function getCurrentMatrixPrices(domainID, priceListItemID, priceType, countryID) {
  return request({
    method: 'get',
    params: { domainID, priceListItemID, priceType, countryID },
    url: 'price-list-item-price/current-matrix'
  });
}

export function getCurrentPrices(domainID, priceType, countryID) {
  return request({
    method: 'get',
    params: { domainID, priceType, countryID },
    url: 'price-list-item-price/current'
  });
}

export function updatePricesForDate(item) {
  return request({
    method: 'post',
    data: item,
    url: 'price-list-item-price/updatePricesForDate'
  });
}

export const storeExtensions = {
  actions: {
    calculatePrices({ dispatch }, data) {
      return new Promise((resolve, reject) =>
        calculatePrices(data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    changeMatrixPrices({ dispatch }, data) {
      return new Promise((resolve, reject) =>
        changeMatrixPrices(data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    changePrices({ dispatch }, data) {
      return new Promise((resolve, reject) =>
        changePrices(data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getCurrentMatrixPrices({ dispatch }, { domainID, priceListItemID, priceType, countryID }) {
      return new Promise((resolve, reject) =>
        getCurrentMatrixPrices(domainID, priceListItemID, priceType, countryID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getCurrentPrices({ dispatch }, { domainID, priceType, countryID }) {
      return new Promise((resolve, reject) =>
        getCurrentPrices(domainID, priceType, countryID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getMatrix({ dispatch }, { priceListItemID }) {
      return new Promise((resolve, reject) =>
        getMatrix(priceListItemID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getPriceMatrix({ dispatch }, params) {
      return new Promise((resolve, reject) =>
        getPriceMatrix(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getLastPrices({ dispatch }, params) {
      return new Promise((resolve, reject) =>
        getLastPrices(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getPrices({ dispatch }, params) {
      return new Promise((resolve, reject) =>
        getPrices(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    updatePricesForDate({ dispatch }, item) {
      return new Promise((resolve, reject) =>
        updatePricesForDate(item)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
